<div class="introduce-comp-wrapper" *ngIf="contentLoaded">
  <app-header></app-header>
  <div class="body-wrapper">
    <div class="banner">
      <div class="container">
        <div class="row flex-column-reverse flex-md-row align-items-center">
          <div class="col-lg-6 col-md-6 col-xs-12">
            <div class="content">
              <span class="name">FPT Wi-Fi 6</span>
              <h1>Wi-Fi thế hệ mới nhất</h1>
              <p>Công nghệ hàng đầu, thiết bị hiện đại số 1</p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-xs-12">
            <div class="image">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/banner-pic-ver2.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-1 advantage" id="advantage">
      <div class="container">
        <div class="list-advantage">
          <div class="row show-on-desktop">
            <div
              class="col-lg-3 col-md-3 col-xs-12"
              *ngFor="let item of advantageList"
            >
              <div class="col-wrapper">
                <div class="icon">
                  <img
                    src="{{ item.icon }}"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="col-content">
                  <h2 class="name">{{ item.title }}</h2>
                  <div class="text">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </div>
          <ngx-slick-carousel class="list-product slide" [config]="slideConfig">
            <div class="item" *ngFor="let item of advantageList" ngxSlickItem>
              <div class="col-wrapper">
                <div class="icon">
                  <img
                    src="{{ item.icon }}"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </div>
                <div class="col-content">
                  <h2 class="name">{{ item.title }}</h2>
                  <div class="text">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>

    <div class="compare">
      <div class="container">
        <div class="compare-wrapper">
          <div class="row flex-column-reverse flex-md-row align-items-center">
            <div class="col-lg-6 col-md-6 col-xs-12">
              <div class="col-wrapper">
                <h2>
                  So sánh
                  <span>Wi-Fi 6</span>
                  <br />với Wi-Fi 5
                </h2>
                <div class="list-ad">
                  <div class="item" *ngFor="let item of to6List">
                    <div class="icon">
                      <img
                        src="{{ item.icon }}"
                        alt=""
                        width="auto"
                        height="auto"
                      />
                    </div>
                    <div class="content">
                      <h3>{{ item.title }}</h3>
                      <p>{{ item.content }}</p>
                    </div>
                  </div>
                </div>
                <button (click)="registerInfo()">
                  <span>Đăng ký</span>
                  <img
                    src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/arrow-right.png"
                    alt=""
                    width="auto"
                    height="auto"
                  />
                </button>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xs-12">
              <div class="image">
                <img
                  src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/modem_home.png"
                  alt=""
                  width="auto"
                  height="auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="qna" id="qna">
      <div class="container">
        <div class="row flex-column-reverse flex-md-row align-items-center">
          <div class="col-lg-6 col-md-6 col-xs-12">
            <div class="col-wrapper">
              <h2>Câu hỏi thường gặp</h2>
              <div class="list-question">
                <div class="item">
                  <div class="accordion-header">
                    <h3>Công nghệ FPT Wi-Fi 6 là gì?</h3>
                    <a (click)="showItem1 = !showItem1"
                      ><img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/add.png"
                        alt=""
                        *ngIf="!showItem1"
                        width="auto"
                        height="auto"
                      />
                      <img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/minus.png"
                        alt=""
                        *ngIf="showItem1"
                        width="auto"
                        height="auto"
                      />
                    </a>
                  </div>
                  <div class="accordion-body" *ngIf="showItem1">
                    <p>
                      Wi-Fi 6, hay 802.11ax, là một trong những chuẩn kết nối
                      không dây mới và phổ biến nhất hiện nay, mang lại những
                      cải tiến vượt trội về tốc độ, khả năng kết nối đồng thời,
                      độ trễ và tối ưu hiệu năng cho các thiết bị đầu cuối.
                      Wi-Fi 6 trở thành lựa chọn lý tưởng cho mọi hoạt động trực
                      tuyến, mở ra phạm vi giải trí chất lượng cao và công việc
                      trực tuyến không gián đoạn.
                    </p>
                    <p>
                      FPT Wi-Fi 6 không chỉ kế thừa mà còn tối ưu hóa những ưu
                      điểm của Wi-Fi 6 để phù hợp với nhu cầu đặc thù của người
                      dùng Việt Nam. Với FPT Wi-Fi 6, người dùng sẽ được trải
                      nghiệm phủ sóng không giới hạn và kết nối siêu vượt trội,
                      đảm bảo một mạng lưới Internet nhanh chóng, ổn định và
                      tiết kiệm năng lượng. Đặc biệt, FPT Telecom đem đến trải
                      nghiệm hoàn hảo thông qua việc kiểm soát, thay đổi, điều
                      chỉnh cấu hình hệ thống Wi-Fi trong nhà qua Hi FPT chỉ
                      bằng vài click đơn giản.
                    </p>
                  </div>
                </div>
                <div class="item">
                  <div class="accordion-header">
                    <h3>FPT Wi-Fi 6 có những ưu điểm nổi bật gì?</h3>
                    <a (click)="showItem2 = !showItem2"
                      ><img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/add.png"
                        alt=""
                        *ngIf="!showItem2"
                        width="auto"
                        height="auto"
                      />
                      <img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/minus.png"
                        alt=""
                        *ngIf="showItem2"
                        width="auto"
                        height="auto"
                      />
                    </a>
                  </div>
                  <div class="accordion-body" *ngIf="showItem2">
                    <ul>
                      <li>
                        Tốc độ kết nối vượt trội: Wi-Fi 6 không chỉ là một bước
                        tiến trong công nghệ mạng không dây; nó còn là bước nhảy
                        vọt về tốc độ. So với Wi-Fi 5, Wi-Fi 6 có thể cung cấp
                        tốc độ cao gấp ba lần, đạt mức tối đa lên đến 9.6 Gbps.
                        Điều này làm cho nó trở thành giải pháp lý tưởng cho
                        việc phát trực tiếp các nội dung đa phương tiện độ phân
                        giải cao và chơi game trực tuyến mà không gặp bất kỳ trở
                        ngại nào về tốc độ.
                      </li>
                      <li>
                        Phủ sóng không giới hạn: Công nghệ beamforming tích hợp
                        trong Wi-Fi 6 giúp tăng cường độ phủ sóng và độ ổn định
                        của tín hiệu bằng cách hướng trực tiếp sóng Wi-Fi đến
                        các thiết bị thay vì phát sóng đều xung quanh. Kết quả
                        là phạm vi phủ sóng rộng hơn và kết nối ổn định hơn ngay
                        cả khi bạn di chuyển xung quanh ngôi nhà hoặc văn phòng.
                      </li>
                      <li>
                        Kết nối đồng thời nhiều thiết bị: Wi-Fi 6 đồng thời hóa
                        truy cập nhiều thiết bị kết nối cùng một lúc mà không
                        làm giảm hiệu suất mạng.
                      </li>
                      <li>
                        Bảo mật cao hơn: Bạn có thể yên tâm về bảo mật thông tin
                        cá nhân khi sử dụng Wi-Fi 6.
                      </li>
                      <li>
                        Tiết kiệm năng lượng: Thiết bị kết nối sử dụng ít năng
                        lượng hơn, giúp tiết kiệm pin và giảm thời gian sạc.
                      </li>
                      <li>
                        Độ trễ thấp: Với các cải tiến về công nghệ, Wi-Fi 6 đảm
                        bảo độ trễ thấp trong truyền dữ liệu, điều cực kỳ quan
                        trọng cho các trò chơi trực tuyến và ứng dụng gọi video.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="item">
                  <div class="accordion-header">
                    <h3>FPT Wi-Fi 6 có hỗ trợ chơi game không?</h3>
                    <a (click)="showItem3 = !showItem3"
                      ><img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/add.png"
                        alt=""
                        *ngIf="!showItem3"
                        width="auto"
                        height="auto"
                      />
                      <img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/minus.png"
                        alt=""
                        *ngIf="showItem3"
                        width="auto"
                        height="auto"
                      />
                    </a>
                  </div>
                  <div class="accordion-body" *ngIf="showItem3">
                    <p>
                      Câu trả lời là CÓ. FPT Wi-Fi 6 được tích hợp thêm Ultra
                      Fast hỗ trợ người dùng, đem đến trải nghiệm chơi game mượt
                      mà và không giới hạn bởi những ưu điểm sau:
                    </p>
                    <ul>
                      <li>
                        Kết Nối Đồng Thời Nhiều Thiết Bị: FPT Wi-Fi 6 cho phép
                        nhiều thiết bị kết nối đồng thời mà vẫn duy trì hiệu
                        suất mạng cao, điều này rất quan trọng khi bạn chơi game
                        trực tuyến trên nhiều thiết bị cùng một lúc.
                      </li>
                      <li>
                        Giảm Giật Lag và Ping: Đạt tốc độ truyền dữ liệu nhanh
                        hơn với Wi-Fi 6, giảm đáng kể tình trạng giật lag và
                        ping trong các trò chơi trực tuyến, mang lại lợi thế
                        trong các màn đấu nhanh.
                      </li>
                      <li>
                        Cải Thiện Trải Nghiệm Game Đa Người Chơi: Hỗ trợ chơi
                        game đa người chơi trực tuyến mượt mà, cho phép bạn và
                        bạn bè cùng tham gia vào các trận đấu mà không lo bị
                        gián đoạn.
                      </li>

                      <li>
                        Tính Năng Bảo Mật Tiên Tiến: Với WPA3, Wi-Fi 6 đảm bảo
                        an toàn thông tin cá nhân và bảo vệ bạn khỏi các mối đe
                        dọa mạng.
                      </li>
                      <li>
                        Độ Ổn Định Cao: Cung cấp kết nối ổn định ngay cả trong
                        điều kiện mạng đông đúc, đảm bảo trải nghiệm game liên
                        tục và không bị gián đoạn.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="item">
                  <div class="accordion-header">
                    <h3>Wi-Fi 6 có gì khác biệt với Wi-Fi 4 và Wi-Fi 5?</h3>
                    <a (click)="showItem4 = !showItem4"
                      ><img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/add.png"
                        alt=""
                        *ngIf="!showItem4"
                        width="auto"
                        height="auto"
                      />
                      <img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/minus.png"
                        alt=""
                        *ngIf="showItem4"
                        width="auto"
                        height="auto"
                      />
                    </a>
                  </div>
                  <div class="accordion-body" *ngIf="showItem4">
                    <ul>
                      <li>
                        Tốc độ truyền dữ liệu:<br />
                        Wi-Fi 4: Tối đa 600Mbps<br />
                        Wi-Fi 5: Tối đa lên đến 3.5 Gbps<br />
                        Wi-Fi 6: Tối đa lên đến 9.5 Gbps
                      </li>
                      <li>
                        Khả năng kết nối đa thiết bị:<br />
                        Wi-Fi 4: Khả năng kết nối có hạn, xảy ra nghẽn mạng khi
                        có nhiều thiết bị kết nối<br />
                        Wi-Fi 5: Sử dụng công nghệ MU-MIMO. Khả năng xử lý đồng
                        thời nhiều thiết bị còn hạn chế<br />
                        Wi-Fi 6: Sử dụng công nghệ OFDMA và MU-MIMO. Khả năng xử
                        lý đồng thời nhiều thiết bị hiệu quả, giảm tình trạng
                        nghẽn mạng
                      </li>
                      <li>
                        Băng tần và băng thông:<br />
                        Wi-Fi 4: Băng tần 2.4 GHz/ 5 GHz. Băng thông chống nhiễu
                        kém<br />
                        Wi-Fi 5: Băng tần 5 GHz. Băng thông tốt nhưng không đa
                        dạng<br />
                        Wi-Fi 6: Băng tần 2.4 GHz và 5 GHz. Băng thông lớn, hiệu
                        suất tốt
                      </li>

                      <li>
                        Hiệu suất trong môi trường đông đúc:<br />
                        Wi-Fi 4: Kém<br />
                        Wi-Fi 5: Không ổn định<br />
                        Wi-Fi 6: Ổn định
                      </li>
                      <li>
                        Tiết kiệm năng lượng:<br />
                        Wi-Fi 4: Không có<br />
                        Wi-Fi 5: Không có<br />
                        Wi-Fi 6: Có. Sử dụng công nghệ Target Wake Time (TWT)
                      </li>
                      <li>
                        Bảo mật:<br />
                        Wi-Fi 4: Tiêu chuẩn WPA2<br />
                        Wi-Fi 5: Tiêu chuẩn WPA2<br />
                        Wi-Fi 6: Tiêu chuẩn WPA3
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="item">
                  <div class="accordion-header">
                    <h3>Làm thế nào để đăng ký gói Wi-Fi 6 FPT?</h3>
                    <a (click)="showItem5 = !showItem5"
                      ><img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/add.png"
                        alt=""
                        *ngIf="!showItem5"
                        width="auto"
                        height="auto"
                      />
                      <img
                        src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/minus.png"
                        alt=""
                        *ngIf="showItem5"
                        width="auto"
                        height="auto"
                      />
                    </a>
                  </div>
                  <div class="accordion-body" *ngIf="showItem5">
                    <p>
                      Để trải nghiệm tốc độ internet nhanh chóng và ổn định của
                      Wi-Fi 6 từ FPT, bạn cần theo các bước sau để đăng ký dịch
                      vụ:
                    </p>
                    <p>
                      Bước 1: Truy cập
                      <a href="https://shop.fpt.vn/" target="_blank"
                        >https://shop.fpt.vn/.</a
                      >
                      Trên thanh công cụ, chọn “Internet” và lựa chọn gói dịch
                      vụ phù hợp
                    </p>
                    <p>
                      Bước 2: Đăng ký và cung cấp thông tin cần thiết theo mẫu.
                      Chọn “Tiếp tục”
                    </p>
                    <p>
                      Bước 3: Chọn gói cước và lịch lắp đặt phù hợp với nhu cầu.
                      Kiểm tra lại thông tin và chọn “Thanh toán”
                    </p>
                    <p>
                      Bước 4: Nhập thông tin thẻ để thanh toán. Kiểm tra lại
                      thông tin và hoàn tất thanh toán
                    </p>
                    <p>
                      Bước 5: Lắp đặt tại nhà: Kỹ thuật viên FPT sẽ đến nhà bạn
                      vào thời gian đã hẹn để tiến hành lắp đặt modem và router
                      Wi-Fi 6. Kỹ thuật viên sẽ cài đặt và cấu hình thiết bị,
                      đảm bảo mạng của bạn hoạt động hiệu quả và ổn định nhất.
                      Hãy yêu cầu hướng dẫn sử dụng và thiết lập các biện pháp
                      bảo mật như cấu hình mật khẩu Wi-Fi mạnh mẽ để đảm bảo an
                      toàn cho mạng nhà bạn.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-xs-12">
            <div class="image">
              <img
                src="https://hi-static.fpt.vn/sys/hifpt/pnc_pdx/landing-wifi6/question-pic.png"
                alt=""
                width="auto"
                height="auto"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="post-section">
      <div class="container">
        <h2>Tin tức về Wi-Fi 6 FPT</h2>
        <div class="list-post row">
          <div
            class="col-lg-4 col-md-6 col-xs-12"
            *ngFor="let item of listPost"
          >
            <a class="col-wrapper" target="_blank" href="{{ item.url }}">
              <div class="image">
                <img src="{{ item.img }}" alt="" width="auto" height="auto" />
              </div>
              <div class="content">
                <h3>{{ item.title }}</h3>
                <p>{{ item.content }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
<app-spinner-layout></app-spinner-layout>
